import React from 'react';
import PropTypes from 'prop-types';
import { handleImageError, handleVideoError } from '../../utils/imageUtils';
import './ProjectCard.css';

const ProjectCard = ({ project, className = '' }) => {
  const { title, company, mediaType, mediaSrc, description, techCategory, flexBasis } = project;

  return (
    <article
      className={`project-card ${className}`}
      style={{ flexBasis }}
      role="listitem"
    >
      <div className="card">
        <div className="text-center">
          <h4 className="project-card-title">{title}</h4>
          
          {company && <p className="project-card-company">{company}</p>}
          
          {mediaType === "video" && mediaSrc && (
            <div className="project-card-media">
              <video
                src={mediaSrc}
                autoPlay
                loop
                muted
                onError={handleVideoError}
                aria-label={`Video for ${title}`}
                className="project-card-video"
              />
            </div>
          )}
          
          {mediaType === "image" && mediaSrc && (
            <div className="project-card-media">
              <img
                src={mediaSrc}
                alt={title}
                onError={(e) => handleImageError(e)}
                loading="lazy"
                className="project-card-image"
              />
            </div>
          )}
          
          {description && (
            <p className="project-card-description">{description}</p>
          )}
          
          {techCategory && techCategory.length > 0 && (
            <div className="project-card-tech">
              <strong>Tech:</strong> {techCategory.join(", ")}
            </div>
          )}
        </div>
      </div>
    </article>
  );
};

ProjectCard.propTypes = {
  project: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    title: PropTypes.string.isRequired,
    company: PropTypes.string,
    mediaType: PropTypes.oneOf(['image', 'video']),
    mediaSrc: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    description: PropTypes.string.isRequired,
    techCategory: PropTypes.arrayOf(PropTypes.string),
    flexBasis: PropTypes.string,
  }).isRequired,
  className: PropTypes.string,
};

export default ProjectCard;

